import React from "react";
import ReactDOM from "react-dom";
import App from "./routers/RouterAdmin";
import "./scss/style.scss";
import "moment/locale/en-gb";
import moment from "moment";

moment.locale("en-gb");
ReactDOM.render(<App />, document.getElementById("app"));
